import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectComponent, NgOptionComponent } from '@ng-select/ng-select';

@Component({
    selector: 'emt-dropdown',
    templateUrl: './dropdown.component.html',
    styleUrls: ['./dropdown.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [
        NgSelectComponent,
        FormsModule,
        ReactiveFormsModule,
        NgOptionComponent,
    ],
})
export class DropdownComponent {
  @Input() placeholder: string;
  @Input() bindValue: string;
  @Input() bindLabel: string;
  @Input() items: any[];
  @Input() control: FormControl;
  @Output() change = new EventEmitter();

  constructor() {}

  changeEvent(model: any) {
    this.change.emit(model);
  }
}
